var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M21.621 9.623c.152-.113.379-.007.379.171v7.456c0 .966-.84 1.75-1.875 1.75H3.875C2.84 19 2 18.216 2 17.25V9.798c0-.182.223-.284.379-.171.875.634 2.035 1.44 6.02 4.141.824.562 2.214 1.743 3.601 1.736 1.395.01 2.813-1.196 3.605-1.736 3.985-2.701 5.141-3.51 6.016-4.145zM12 14.333c.906.015 2.21-1.064 2.867-1.509 5.184-3.511 5.578-3.817 6.774-4.692a.855.855 0 00.359-.69V6.75C22 5.784 21.16 5 20.125 5H3.875C2.84 5 2 5.784 2 6.75v.693c0 .27.133.521.36.689 1.195.871 1.59 1.181 6.773 4.692.656.445 1.96 1.524 2.867 1.51z"
  }))));
}

export default SvgEnvelope;